function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2446 1.60217H8.75537V13.3959H15.2446V1.60217Z",
  fill: "#FF5F00"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.16738 7.5C9.16738 5.10833 10.2757 2.97708 12 1.60417C10.7392 0.6 9.14678 0 7.41631 0C3.32086 0 0 3.35833 0 7.5C0 11.6417 3.32086 15 7.41631 15C9.14678 15 10.7372 14.4 12 13.3958C10.2757 12.0229 9.16738 9.89167 9.16738 7.5Z",
  fill: "#EB001B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24 7.5C24 11.6417 20.6791 15 16.5837 15C14.8532 15 13.2628 14.4 12 13.3958C13.7243 12.0229 14.8326 9.89167 14.8326 7.5C14.8326 5.10833 13.7243 2.97708 12 1.60417C13.2608 0.6 14.8532 0 16.5837 0C20.6791 0 24 3.35625 24 7.5ZM23.2913 12.1458V11.9042H23.3882V11.8542H23.143V11.9042H23.2398V12.1458H23.2913ZM23.7672 12.1458V11.8542H23.693L23.6065 12.0542L23.52 11.8542H23.4458V12.1458H23.4994V11.9271L23.5797 12.1167H23.6354L23.7157 11.9271V12.1479H23.7672V12.1458Z",
  fill: "#F79E1B"
});

function SvgIconMastercardSingle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMastercardSingle);
export default __webpack_public_path__ + "static/media/icon-mastercard-single.a275583a.svg";
export { ForwardRef as ReactComponent };